import SeedlyngLogo from '@/assets/branding/seedlyng/seedlyng-horizontal.png';

const colors = {
  // Brand colors
  brand_primary: '#0779FF',
  brand_primary_hover: '#175CD3',
  brand_primary_highlight: '#84CAFF',
  brand_primary_mid: '#1C86FF',
  brand_primary_dark: '#043E80',
  brand_secondary: '#2F6CCE',
  brand_accent_start: '#1A84FF',
  brand_accent_end: '#6B63E6',
  brand_accent_light_start: '#EAF3FF',
  brand_accent_light_end: '#E9E7FF',
  brand_complementary_accent: 'rgb(255,150,27)',
  brand_auth_gradient_mid: '#2F6CCE',
  brand_auth_gradient_end: '#043E80',
  brand_auth_warp_mid: '#1C86FF',
};

export default {
  name: 'Seedlyng',
  isSAML: true,
  allowPersonalCourses: false,
  logo: SeedlyngLogo,
  colors,
};
